//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import manba from 'manba'
import { axiosPost } from '../../../axios/axios.js'
import { convertTime } from '../../../components/helpers.js'
import ReportArhiveObjectFullInform from './ReportArhiveObjectFullInform.vue'
import { getLegend, getLegendConfigTypes, getToken, getEmployees } from './reportArhive.js'

export default {
  components: {
    ReportArhiveObjectFullInform
  },
  props: {
    request: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data: function () {
    return {
      dataActObject: null,
      expandedActFull: {},
      token: null,
      legendConfig: [],
      troubleTypeConfig: [],
      columnsEquipment: [
        {
          name: 'name',
          label: 'Наименование материала',
          align: 'left',
          field: 'name',
          sortable: true
        },
        {
          name: 'quantity',
          label: 'Количество',
          align: 'left',
          field: 'quantity',
          style: 'min-width: 100px;'
        }
      ],
      pagination: {
        rowsPerPage: 0
      },
      legendConfigTypes: {},
      listEmployees: []
    }
  },
  computed: {
    getListEmployees: function () {
      return getEmployees()
    }
  },
  watch: {
    getListEmployees: {
      handler: function (data) {
        data.then(employees => {
          this.listEmployees = employees
        })
      },
      immediate: true
    }
  },
  created: function () {
    this.legendConfig = getLegend(this.request.type)
    this.legendConfigTypes = getLegendConfigTypes(this.legendConfig)
    if (this.request && this.request.type && ['tl', 't7', 'kto'].includes(this.request.type)) {
      this.getTroubleType()
    }
    this.getDataActObject()
  },
  methods: {
    formatDateTime: function (unixTime) {
      return unixTime ? convertTime(unixTime * 1000) : ''
    },
    updateToken: function () {
      getToken()
        .then((response) => {
          if (response.data.error_code == 0) {
            this.token = response.data.token
          }
        })
    },
    getDataActObject: function () {
      if (Object.keys(this.request).length) {
        this.$q.loading.show({ spinnerColor: 'blue-11', message: 'Загрузка архивных данных...' })
        let token = 'XSRF-TOKEN'
        getToken()
          .then((response) => {
            if (response.data.error_code == 0) {
              token = response.data.token
              const bodyFormData = new FormData() // new URLSearchParams() //
              this.token = token
              bodyFormData.append('token', token)
              bodyFormData.append('type', this.request.type ? this.request.type : null)
              bodyFormData.append('object_number', this.request.objectNumber ? this.request.objectNumber : null)
              bodyFormData.append('act_id', this.request.actId ? this.request.actId : null)
              bodyFormData.append('start_datetime', this.request.startDateTime ? this.request.startDateTime : null)
              bodyFormData.append('end_datetime', this.request.endDateTime ? this.request.endDateTime : null)
              return axiosPost({
                url: 'api-v1/api-act-objects/get-acts',
                config: {
                  headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                  },
                  withCredentials: true
                },
                data: bodyFormData,
                onSuccess: (response) => {
                  this.dataActObject = response.data.data
                  this.dataActObject.forEach((item, itemIndex) => {
                    const creator = this.listEmployees.find(element => element.name == item.create.employee_name)
                    const upprover = item.upprove !== undefined ? this.listEmployees.find(element => element.name == item.upprove.employee_name) : undefined
                    const worker = item.work !== undefined ? this.listEmployees.find(element => element.name == item.work.employee_name) : undefined
                    const installer = item.work !== undefined ? this.listEmployees.find(element => element.name == item.work.installer_name) : undefined
                    const auditor = item.audit !== undefined ? this.listEmployees.find(element => element.name == item.audit.auditor_name) : undefined
                    const driver = item.auto !== undefined ? this.listEmployees.find(element => element.name == item.auto.driver) : undefined
                    const brigadeEmployee = item.brigade && item.brigade.employee_name !== undefined ? this.listEmployees.find(element => element.name == item.brigade.employee_name) : undefined
                    const employeesBrigade = []
                    if (item.brigade && item.brigade.employees !== undefined) {
                      const employees = item.brigade.employees.split(',')
                      employees.forEach(name => {
                        const employee = this.listEmployees.find(element => element.name == name)
                        employeesBrigade.push({ name: name, link: (employee ? employee.id : undefined) })
                      })
                    }
                    if (creator !== undefined) {
                      this.$set(this.dataActObject[itemIndex].create, 'employee_link', creator.id)
                    }
                    if (upprover !== undefined) {
                      this.$set(this.dataActObject[itemIndex].upprove, 'employee_link', upprover.id)
                    }
                    if (worker !== undefined) {
                      this.$set(this.dataActObject[itemIndex].work, 'employee_link', worker.id)
                    }
                    if (installer !== undefined) {
                      this.$set(this.dataActObject[itemIndex].work, 'installer_link', installer.id)
                    }
                    if (auditor !== undefined) {
                      this.$set(this.dataActObject[itemIndex].audit, 'employee_link', auditor.id)
                    }
                    if (driver !== undefined) {
                      this.$set(this.dataActObject[itemIndex].auto, 'employee_link', driver.id)
                    }
                    if (brigadeEmployee !== undefined) {
                      this.$set(this.dataActObject[itemIndex].brigade, 'employee_link', brigadeEmployee.id)
                    }
                    if (employeesBrigade.length > 0) {
                      this.$set(this.dataActObject[itemIndex].brigade, 'links', employeesBrigade)
                    }
                    if (item.claims.external && item.claims.external.length) {
                      item.claims.external.forEach((external, indexExternal) => {
                        const creatorExternal = this.listEmployees.find(element => element.name == external.creator_name)
                        if (creatorExternal !== undefined) {
                          this.$set(this.dataActObject[itemIndex].claims.external[indexExternal], 'link', creatorExternal.id)
                        }
                      })
                    }
                    if (item.claims.internal && item.claims.internal.length) {
                      item.claims.internal.forEach((internal, indexInternal) => {
                        const creatorInternal = this.listEmployees.find(element => element.name == internal.creator_name)
                        if (creatorInternal !== undefined) {
                          this.$set(this.dataActObject[itemIndex].claims.internal[indexInternal], 'link', creatorInternal.id)
                        }
                      })
                    }
                    this.$set(this.expandedActFull, 'expanded_' + item.act.id, false)
                  })
                  return Promise.resolve(true)
                },
                onFailure: (response) => {
                  this.dataActObject = null
                  this.$q.notify({
                    type: 'negative',
                    message: response.message,
                    progress: true,
                    timeout: 10000
                  })
                }
              })
            }
          })
          .finally(() => {
            this.$q.loading.hide()
          })
      }
    },
    getTroubleType: function () {
      this.troubleTypeConfig = []
      this.troubleTypeConfig.push({ id: 1, color: 'black', name: 'Черный' })
      this.troubleTypeConfig.push({ id: 2, color: 'yellow', name: 'Желтое мигание' })
      this.troubleTypeConfig.push({ id: 3, color: 'indigo-14', name: 'Развернут' })
      this.troubleTypeConfig.push({ id: 4, color: 'purple', name: 'Комплексные работы (ТЗ)' })
      this.troubleTypeConfig.push({ id: 5, color: 'grey', name: 'Остальное' })
      this.troubleTypeConfig.push({ id: 6, color: 'deep-orange-13', name: 'Нарушение внешнего вида' })
      this.troubleTypeConfig.push({ id: 8, color: 'cyan-12', name: 'Режим работы' })
    },
    getStateClass: function (id) {
      let name = ''
      const legend = this.legendConfig.find(item => item.id == id || (item.add && item.add == id))
      if (legend !== undefined) {
        name = legend.class ? legend.class : ('bg-' + legend.bg + ' text-' + (legend.colorBody ? legend.colorBody : legend.color))
      }
      return name
    },
    getClassPriority: function (act) {
      let id = 0
      let className = ''
      if (act.blocked !== undefined && act.priority !== undefined) {
        if (+act.blocked) {
          id = -100
        } else {
          if (+act.priority == 1) {
            id = 1000
          } else if (+act.priority == 2) {
            id = 1001
          }
        }
        className = this.getStateClass(id)
      }
      return className == '' ? ' bg-grey-3 text-black ' : className
    },
    getItemColumn: function (item, side) {
      const itemsObject = []
      const typeObject = this.request.type
      itemsObject.push({
        name: 'Объект ' + this.request.typeName,
        article: [{ key: 'table', index: 1 }, { key: 'detector', index: 1 }, { key: 'tl', index: 1 }, { key: 't7', index: 1 }, { key: 'kto', index: 2 }, { key: 'fvf', index: 1 }],
        value: item.object.number + ' - ' + item.object.address,
        side: 'left'
      })
      if (item.object.boundary !== undefined) {
        itemsObject.push({
          name: 'Рубеж',
          article: [{ key: 'fvf', index: 2 }],
          value: item.object.boundary.value,
          side: 'left'
        })
      }
      if (item.object.number_complex !== undefined) {
        itemsObject.push({
          name: 'Комплекс',
          article: [{ key: 'fvf', index: 3 }],
          value: item.object.number_complex.value,
          side: 'left'
        })
      }
      if (item.act.text_warning !== undefined && item.act.text_warning !== '') {
        itemsObject.push({
          name: '',
          article: [{ key: 'kto', index: 1 }],
          value: item.act.text_warning,
          html: true,
          class: 'text-bold text-negative',
          side: 'left'
        })
      }
      if (item.act.note_impossible !== undefined && item.act.note_impossible !== '') {
        itemsObject.push({
          name: 'Причина невыполнения',
          article: [{ key: 'kto', index: 3 }, { key: 'fvf', index: 4 }],
          value: item.act.note_impossible,
          html: true,
          side: 'left'
        })
      }
      if (item.act.approved_ready !== undefined) {
        itemsObject.push({
          name: 'Готов к утверждению',
          article: [{ key: 'kto', index: 7 }],
          value: item.act.approved_ready,
          side: 'left'
        })
      }
      if (item.object.balance !== undefined) {
        itemsObject.push({
          name: 'Баланс ЦОДД',
          article: [{ key: 'tl', index: 2 }, { key: 't7', index: 2 }],
          value: item.object.balance ? 'Да' : 'Нет',
          side: 'left'
        })
      }
      if (item.object.gos_contract !== undefined) {
        itemsObject.push({
          name: 'Госконтракт',
          article: [{ key: 'tl', index: 3 }, { key: 't7', index: 3 }],
          value: item.object.gos_contract.name,
          state: !item.object.gos_contract.state,
          side: 'left'
        })
      }
      if (item.object.contract !== undefined) {
        itemsObject.push({
          name: 'Контракт',
          article: [{ key: 'tl', index: 4 }, { key: 't7', index: 4 }],
          value: item.object.contract,
          side: 'left'
        })
      }
      if (item.act.add_date !== undefined) {
        itemsObject.push({
          name: 'Дата акта',
          article: [{ key: 'tl', index: 7 }, { key: 't7', index: 7 }],
          value: this.formatDateTime(item.act.add_date),
          side: 'left'
        })
      }
      if (item.act.modify_date !== undefined) {
        itemsObject.push({
          name: 'Дата одобрения',
          article: [{ key: 'tl', index: 9 }, { key: 't7', index: 9 }],
          value: this.formatDateTime(item.act.modify_date),
          side: 'left'
        })
      }
      // СО: index 10,11,12 - Заявка
      let countClaims = 0
      let indexRow = 10
      const statusColor = [{ id: 281, color: 'light-green-10' }, { id: 282, color: 'red-10' }, { id: 291, color: 'blue-10' }]
      if (item.claims !== undefined && item.claims.external !== undefined && item.claims.external.length) {
        const troubleDefault = this.troubleTypeConfig.find(troubleType => troubleType.id == 5)
        item.claims.external.forEach(claim => {
          const trouble = this.troubleTypeConfig.find(troubleType => troubleType.id == +claim.type)
          const colorClaimStatus = statusColor.find(claimStatus => claimStatus.id == claim.status_id)
          itemsObject.push({
            name: '',
            article: [{ key: 'tl', index: indexRow }, { key: 't7', index: indexRow }, { key: 'kto', index: indexRow++ }],
            value: claim.name,
            icon: {
              name: 'mdi-circle',
              color: trouble !== undefined ? trouble.color : troubleDefault.color
            },
            claim: {
              name: 'mdi-earth',
              color: 'green-8',
              status: claim.status_name,
              class: 'q-pa-xs bg-' + (colorClaimStatus !== undefined ? colorClaimStatus.color : 'blue-grey-8') + ' text-deep-purple-1'
            },
            side: (['tl', 't7'].includes(typeObject) ? 'left' : 'right')
          })
          itemsObject.push({
            name: 'Описание',
            article: [{ key: 'tl', index: indexRow }, { key: 't7', index: indexRow }, { key: 'kto', index: indexRow++ }],
            value: claim.description,
            side: (['tl', 't7'].includes(typeObject) ? 'left' : 'right')
          })
          itemsObject.push({
            name: 'Комментарий к заявке',
            article: [{ key: 'tl', index: indexRow }, { key: 't7', index: indexRow }, { key: 'kto', index: indexRow++ }],
            value: claim.comment,
            side: (['tl', 't7'].includes(typeObject) ? 'left' : 'right')
          })
          countClaims++
        })
      }
      if (item.claims !== undefined && item.claims.internal !== undefined && item.claims.internal.length) {
        item.claims.internal.forEach(claim => {
          const colorClaimStatus = statusColor.find(claimStatus => claimStatus.id == claim.status_id)
          itemsObject.push({
            name: '',
            article: [{ key: 'tl', index: indexRow }, { key: 't7', index: indexRow }, { key: 'kto', index: indexRow++ }],
            value: claim.name,
            claim: {
              name: 'mdi-home',
              color: 'indigo-10',
              status: claim.status_name,
              class: 'q-pa-xs bg-' + (colorClaimStatus !== undefined ? colorClaimStatus.color : 'blue-grey-8') + ' text-deep-purple-1'
            },
            side: (['tl', 't7'].includes(typeObject) ? 'left' : 'right')
          })
          itemsObject.push({
            name: 'Описание',
            article: [{ key: 'tl', index: indexRow }, { key: 't7', index: indexRow }, { key: 'kto', index: indexRow++ }],
            value: claim.description,
            side: (['tl', 't7'].includes(typeObject) ? 'left' : 'right')
          })
          itemsObject.push({
            name: 'Комментарий к заявке',
            article: [{ key: 'tl', index: indexRow }, { key: 't7', index: indexRow }, { key: 'kto', index: indexRow++ }],
            value: claim.comment,
            side: (['tl', 't7'].includes(typeObject) ? 'left' : 'right')
          })
          countClaims++
        })
      }
      itemsObject.push({
        name: ['tl', 't7'].includes(typeObject) ? 'Сотрудник' : 'Акт создал',
        article: [{ key: 'tl', index: 5 }, { key: 't7', index: 5 }, { key: 'detector', index: 7 }],
        value: item.create.employee_name,
        link: item.create.employee_link !== undefined ? item.create.employee_link : null,
        side: 'left'
      })

      itemsObject.push({
        name: 'Бригада',
        article: [{ key: 'table', index: 2 }, { key: 'detector', index: 12 }, { key: 'tl', index: 6 }, { key: 't7', index: 6 }, { key: 'kto', index: 4 }, { key: 'fvf', index: 5 }],
        value: item.brigade.name,
        side: ['table', 'tl', 't7', 'kto', 'fvf'].includes(typeObject) ? 'left' : 'right'
      })

      itemsObject.push({
        name: ['fvf'].includes(typeObject) ? 'Ответственный' : 'Инженер',
        article: [{ key: 'table', index: 3 }, { key: 'kto', index: 5 }, { key: 'fvf', index: 6 }],
        value: item.work.employee_name,
        link: item.work.employee_link !== undefined ? item.work.employee_link : null,
        side: 'left'
      })
      itemsObject.push({
        name: 'Примечание инженера',
        article: [{ key: 'table', index: 4 }, { key: 'detector', index: 14 }, { key: 'kto', index: 6 }, { key: 'fvf', index: 7 }],
        value: item.work.note,
        side: (['table', 'kto', 'fvf'].includes(typeObject) ? 'left' : 'right'),
        html: true
      })
      itemsObject.push({
        name: ['tl', 't7'].includes(typeObject) ? 'Дата выполнения работ' : 'Время выполнения работ',
        article: [{ key: 'detector', index: 6 }, { key: 'tl', index: countClaims + 13 }, { key: 't7', index: countClaims + 13 }],
        value: this.formatDateTime(item.work.time),
        side: 'left'
      })
      if (item.create.note && item.create.note !== '') {
        itemsObject.push({
          name: 'Примечание к акту',
          article: [{ key: 'detector', index: 8 }, { key: 'tl', index: countClaims + 14 }, { key: 't7', index: countClaims + 14 }],
          value: item.create.note,
          side: 'left',
          html: true
        })
      }
      if (item.object.amperage !== undefined) {
        itemsObject.push({
          name: 'Замер потребляемого тока СО(приложить фото)',
          article: [{ key: 'tl', index: countClaims + 15 }, { key: 't7', index: countClaims + 15 }],
          value: item.object.amperage,
          side: 'left'
        })
      }
      if (item.auto.driver !== undefined && item.auto.driver !== '') {
        itemsObject.push({
          name: 'Водитель',
          article: [{ key: 'tl', index: countClaims + 17 }, { key: 't7', index: countClaims + 17 }],
          value: item.auto.driver,
          link: item.auto.employee_link !== undefined ? item.auto.employee_link : null,
          side: 'left'
        })
      }
      if (item.act.set_arrow !== undefined && item.act.set_arrow !== '') {
        itemsObject.push({
          name: 'Требуется нанесение контурных стрелок',
          article: [{ key: 'tl', index: countClaims + 18 }, { key: 't7', index: countClaims + 18 }],
          value: item.act.set_arrow,
          side: 'right'
        })
      }
      if (item.act.need_tower !== undefined && item.act.need_tower !== '') {
        itemsObject.push({
          name: 'Требуется вышка',
          article: [{ key: 'tl', index: countClaims + 19 }, { key: 't7', index: countClaims + 19 }],
          value: item.act.need_tower,
          side: 'right'
        })
      }
      if (item.object.current_control_before !== undefined) {
        itemsObject.push({
          name: 'Контроль тока (ППК) До',
          article: [{ key: 'tl', index: countClaims + 20 }, { key: 't7', index: countClaims + 20 }],
          value: item.object.current_control_before.in_act_value,
          icon: {
            name: 'mdi-check-circle-outline',
            color: item.object.current_control_before.not_required ? 'negative' : 'green-8',
            tooltip: !item.object.current_control_before.not_required ? 'Обязательно к заполнению' : 'Не обязательно к заполнению'
          },
          side: 'right'
        })
      }
      if (item.object.current_control !== undefined) {
        itemsObject.push({
          name: 'Контроль тока (ППК) После',
          article: [{ key: 'tl', index: countClaims + 21 }, { key: 't7', index: countClaims + 21 }],
          value: item.object.current_control.in_act_value,
          icon: {
            name: 'mdi-check-circle-outline',
            color: item.object.current_control.not_required ? 'negative' : 'green-8',
            tooltip: !item.object.current_control.not_required ? 'Обязательно к заполнению' : 'Не обязательно к заполнению'
          },
          side: 'right'
        })
      }
      if (item.act.note_current_control !== undefined && item.act.note_current_control !== '') {
        itemsObject.push({
          name: 'Комментарий для контроля тока, если не выбрано "Включен полностью"',
          article: [{ key: 'tl', index: countClaims + 22 }, { key: 't7', index: countClaims + 22 }],
          value: item.act.note_current_control,
          class: 'q-pa-xs bg-yellow-1',
          html: true,
          side: 'right'
        })
      }
      // itemsObject.push({ name: 'Комментарий сменного ', value: item.upprove.note ?????, side: 'left' })
      if (item.works && item.works !== '') {
        itemsObject.push({ name: 'Были проведены следующие работы', article: [{ key: 'table', index: 5 }], value: item.works, side: 'left' })
      }
      itemsObject.push({
        name: 'Авто',
        article: [{ key: 'table', index: 6 }, { key: 'detector', index: 13 }, { key: 'tl', index: countClaims + 16 }, { key: 't7', index: countClaims + 16 }],
        value: item.auto.id !== '' ? (item.auto.number + ' - ' + item.auto.description) : '(Не задано)',
        side: ['table', 'tl', 't7'].includes(typeObject) ? 'left' : 'right'
      })
      if (item.upprove && item.upprove.employee_id !== '') {
        itemsObject.push({
          name: ['tl', 't7'].includes(typeObject) ? 'Диспетчер' : 'Оператор',
          article: [{ key: 'table', index: 7 }, { key: 'detector', index: 9 }, { key: 'tl', index: 8 }, { key: 't7', index: 8 }, { key: 'kto', index: countClaims + 7 }, { key: 'fvf', index: 8 }],
          value: item.upprove.employee_name,
          link: item.upprove.employee_link !== undefined ? item.upprove.employee_link : null,
          side: (['table', 'kto', 'fvf'].includes(typeObject) ? 'right' : 'left')
        })
        if (item.upprove.note && item.upprove.note !== '') {
          itemsObject.push({
            name: 'Примечание оператора',
            article: [{ key: 'table', index: 8 }, { key: 'detector', index: 10 }, { key: 'kto', index: countClaims + 8 }, { key: 'fvf', index: 9 }],
            value: item.upprove.note,
            side: (['table', 'kto', 'fvf'].includes(typeObject) ? 'right' : 'left')
          })
        }
      }
      if (item.work.note_blocked && item.work.note_blocked !== '') {
        itemsObject.push({ name: 'Примечание оператора', article: [{ key: 'detector', index: 11 }], value: item.work.note_blocked, side: 'left' })
      }
      itemsObject.push({
        name: ['fvf'].includes(typeObject) ? 'Акт создан' : 'Время создания акта',
        article: [{ key: 'table', index: 9 }, { key: 'kto', index: countClaims + 9 }, { key: 'fvf', index: 10 }],
        value: this.formatDateTime(item.create.time),
        side: 'right'
      })
      itemsObject.push({
        name: 'Время выполнения работ',
        article: [{ key: 'table', index: 10 }, { key: 'kto', index: countClaims + 10 }, { key: 'fvf', index: 12 }],
        value: this.formatDateTime(item.work.time),
        side: 'right'
      })
      if (item.create.note && item.create.note !== '') {
        itemsObject.push({
          name: 'Примечание',
          article: [{ key: 'table', index: 11 }, { key: 'kto', index: countClaims + 11 }, { key: 'fvf', index: 11 }],
          value: item.create.note,
          side: 'right'
        })
      }
      if (item.object.type_name !== undefined) {
        itemsObject.push({ name: 'Тип датчика', article: [{ key: 'detector', index: 2 }], value: item.object.type_name.object, side: 'left' })
      }
      if (item.object.type_addition !== undefined) {
        itemsObject.push({
          name: 'Доп.информация к датчику SMS',
          article: [{ key: 'detector', index: 3 }],
          value: item.object.type_addition.object,
          side: 'left'
        })
      }
      if (item.work.date_run) {
        itemsObject.push({
          name: 'Дата начала выполнения',
          article: [{ key: 'detector', index: 4 }],
          value: this.formatDateTime(item.work.date_run),
          side: 'left'
        })
      }
      if (item.work.date_precomplete) {
        itemsObject.push({
          name: 'Время предготовности акта',
          article: [{ key: 'detector', index: 5 }],
          value: this.formatDateTime(item.work.date_precomplete),
          side: 'left'
        })
      }

      if (item.jobs && item.jobs.length) {
        const jobs = []
        const legend = this.legendConfig.find(itemLegend => itemLegend.id == item.state.id || (itemLegend.add && itemLegend.add == item.state.id))
        const jobClass = (legend !== undefined && legend.bgJob !== undefined) ? (' bg-' + legend.bgJob + ' text-' + legend.colorJob) : ' '
        item.jobs.forEach(job => {
          let icon = 'mdi-close'
          let color = 'negative'
          if (!job.children.length) {
            if ([1, 2].includes(job.status)) {
              icon = (job.status == 1 ? 'mdi-check' : 'mdi-restart')
              color = (job.status == 1 ? 'green-8' : 'blue')
            }
            jobs.push({ name: job.name, icon: icon, color: color, class: jobClass })
          } else {
            job.children.forEach(child => {
              icon = 'mdi-close'
              color = 'negative'
              if ([1, 2].includes(child.status)) {
                icon = (child.status == 1 ? 'mdi-check' : 'mdi-restart')
                color = (child.status == 1 ? 'green-8' : 'blue')
              }
              jobs.push({ name: child.name, icon: icon, color: color, class: jobClass })
            })
          }
        })
        itemsObject.push({
          name: 'Виды работ',
          article: [{ key: 'detector', index: 15 }, { key: 'kto', index: countClaims + 12 }],
          value: jobs,
          side: 'right',
          jobs: true
        })
      }
      if (item.audit && item.audit.auditor_name !== '') {
        itemsObject.push({
          name: 'Аудитор',
          article: [{ key: 'detector', index: 16 }, { key: 'tl', index: countClaims + 30 }, { key: 't7', index: countClaims + 30 }],
          value: item.audit.auditor_name,
          link: item.audit.employee_link !== undefined ? item.audit.employee_link : null,
          side: ['detector'].includes(typeObject) ? 'left' : 'right'
        })
        if (item.audit.result && item.audit.result !== '') {
          itemsObject.push({
            name: 'Аудит не пройден',
            article: [{ key: 'detector', index: 17 }],
            value: item.audit.result.replace(/margin-left:-/g, 'margin-left:'),
            side: 'left',
            class: 'bg-red-3',
            html: true
          })
        }
        itemsObject.push({
          name: 'Время аудита',
          article: [{ key: 'detector', index: 18 }],
          value: this.formatDateTime(item.audit.time),
          side: 'left'
        })
        if (item.audit.note && item.audit.note !== '' && item.audit.note !== '<br/>') {
          itemsObject.push({
            name: 'Примечание аудитора',
            article: [{ key: 'detector', index: 19 }],
            value: item.audit.note,
            side: 'left',
            class: 'bg-red-3',
            html: true
          })
        }
      }
      if (item.materials_description !== undefined && item.materials_description !== '') {
        itemsObject.push({
          name: 'Расход материалов',
          article: [{ key: 'tl', index: countClaims + 29 }, { key: 't7', index: countClaims + 29 }],
          value: item.materials_description,
          side: 'right'
        })
      }
      if (item.equipments !== undefined) {
        if (item.equipments.install !== undefined && item.equipments.install.length) {
          itemsObject.push({
            name: 'Монтаж',
            article: [{ key: 'detector', index: 20 }, { key: 'tl', index: countClaims + 23 }, { key: 't7', index: countClaims + 23 }],
            value: item.equipments.storage_name,
            side: ['detector'].includes(typeObject) ? 'left' : 'right'
          })
          itemsObject.push({
            name: '',
            article: [{ key: 'detector', index: 21 }, { key: 'tl', index: countClaims + 24 }, { key: 't7', index: countClaims + 24 }],
            value: item.equipments.install,
            side: ['detector'].includes(typeObject) ? 'left' : 'right',
            table: true
          })
        }
        if (item.equipments.remote !== undefined && item.equipments.remote.length) {
          itemsObject.push({
            name: 'Демонтаж',
            article: [{ key: 'detector', index: 22 }, { key: 'tl', index: countClaims + 25 }, { key: 't7', index: countClaims + 25 }],
            value: item.equipments.storage_name,
            side: ['detector'].includes(typeObject) ? 'left' : 'right'
          })
          itemsObject.push({
            name: '',
            article: [{ key: 'detector', index: 23 }, { key: 'tl', index: countClaims + 26 }, { key: 't7', index: countClaims + 26 }],
            value: item.equipments.remote,
            side: ['detector'].includes(typeObject) ? 'left' : 'right',
            table: true
          })
        }
        if (item.equipments['1C'] !== undefined && item.equipments['1C'].length) {
          itemsObject.push({
            name: '1C',
            article: [{ key: 'detector', index: 24 }, { key: 'tl', index: countClaims + 27 }, { key: 't7', index: countClaims + 27 }],
            value: item.equipments.storage_name,
            side: ['detector'].includes(typeObject) ? 'left' : 'right'
          })
          itemsObject.push({
            name: '',
            article: [{ key: 'detector', index: 25 }, { key: 'tl', index: countClaims + 28 }, { key: 't7', index: countClaims + 28 }],
            value: item.equipments['1C'],
            side: ['detector'].includes(typeObject) ? 'left' : 'right',
            table: true
          })
        }
      }

      return itemsObject.filter(itemObj => {
        return itemObj.side == side && itemObj.article.find(element => element.key == typeObject) !== undefined
      }).sort((previous, next) => {
        const indexPrevious = previous.article.find(element => element.key == typeObject).index
        const indexNext = next.article.find(element => element.key == typeObject).index
        return (indexPrevious > indexNext) ? 1 : -1
      })
    },
    onOpenFullInformation: function (item) {
      this.expandedActFull['expanded_' + item.act.id] = !this.expandedActFull['expanded_' + item.act.id]
    },
    getJobIcons: function (jobs) {
      if (!jobs || !jobs.length) {
        return []
      }
      const listJobIcons = []
      if (this.request && this.request.type) {
        if (this.request.type == 'table') {
          const iconFlashBlue = jobs.find((item) => item.id == 3 ||
                            (item.children && item.children.find(child => child.id == 3) !== undefined))
          if (iconFlashBlue !== undefined) {
            listJobIcons.push({ icon: 'mdi-flash', class: 'bg-indigo-9', color: 'indigo-11' })
          }
          const iconFlashYellow = jobs.find((item) => item.id == 4 ||
                              (item.children && item.children.find(child => child.id == 4) !== undefined))
          if (iconFlashYellow !== undefined) {
            listJobIcons.push({ icon: 'mdi-flash', class: 'bg-yellow', color: 'indigo-11' })
          }
          const iconWrenchRed = jobs.find((item) => item.id == 42 ||
                            (item.children && item.children.find(child => child.id == 42) !== undefined))
          if (iconWrenchRed !== undefined) {
            listJobIcons.push({ icon: 'mdi-wrench', class: 'bg-red', color: 'red-2' })
          }
          const iconWrenchGreen = jobs.find((item) => item.id == 101 ||
                              (item.children && item.children.find(child => child.id == 101) !== undefined))
          if (iconWrenchGreen !== undefined) {
            listJobIcons.push({ icon: 'mdi-wrench', class: 'bg-green', color: 'yellow' })
          }
          const iconWrenchGreenCyan = jobs.find((item) => item.id == 144 ||
                                  (item.children && item.children.find(child => child.id == 144) !== undefined))
          if (iconWrenchGreenCyan !== undefined) {
            listJobIcons.push({ icon: 'mdi-wrench', class: 'bg-cyan-12', color: 'yellow' })
          }
        }
      }
      return listJobIcons
    },
    getActIcons: function (act) {
      const listActIcons = []
      if (this.request && this.request.type) {
        if (this.request.type == 'detector') {
          if (act.offline !== undefined && act.offline) {
            listActIcons.push({ icon: 'mdi-circle', color: 'black', tooltip: 'Оффлайн по заявке' })
          }
          if (act.special !== undefined && act.special) {
            listActIcons.push({ icon: 'mdi-alert-circle', color: 'negative', tooltip: 'Спецзадание' })
          }
          if (act.unavailable_audit !== undefined && act.unavailable_audit) {
            listActIcons.push({ icon: 'mdi-minus-circle', color: 'negative', tooltip: 'Объект недоступен для аудита' })
          }
        } else if (['tl', 't7'].includes(this.request.type)) {
          const legend = getLegendConfigTypes(this.legendConfig)
          Object.entries(legend).forEach(([key, item]) => {
            if (act[key] !== undefined && act[key] == 'Да') {
              listActIcons.push({ icon: item.icon, color: item.colorSuccess, tooltip: item.name })
            }
          })
        } else if (['kto', 'fvf'].includes(this.request.type)) {
          if (act.special !== undefined && act.special == 'Да') {
            listActIcons.push({ icon: 'mdi-alert-circle', color: 'negative', tooltip: 'Спецзадание' })
          }
          if (act.type_id !== undefined) {
            const legend = this.legendConfig.find(item => item.type == act.type_id)
            listActIcons.push({ icon: legend.icon, color: legend.colorSuccess, tooltip: legend.name })
          }
          if (act.speed_limit_warning !== undefined) {
            listActIcons.push({ knob: +act.speed_limit_warning, tooltip: 'Ограничение скорости' })
          }
        }
      }
      return listActIcons
    }
  }
}
